import { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import NavBar from "../layout/NavBar";
import "../styles/pagos.css";
import { toast } from "react-toastify";
import { http } from "../auth";

/*-----Iconos-----*/
import { MdArrowForwardIos, MdNewspaper, MdOutlineCreditCard, MdDeleteOutline, MdStore } from "react-icons/md";
import { RiBankFill } from "react-icons/ri";
import { AiFillDollarCircle, AiOutlineGlobal } from "react-icons/ai";
import { IoMdInformationCircle } from "react-icons/io";
import { PiFilePdf } from "react-icons/pi";
import { Row, Col, Modal } from "react-bootstrap";
import Overlay from "react-bootstrap/Overlay";
import Tooltip from "react-bootstrap/Tooltip";
import { LiaIndustrySolid } from "react-icons/lia";
import { MdOutlineFactory } from "react-icons/md";
import { Link } from "react-router-dom";
import { ThemeContext } from "../App";
import { useThemeManager } from "../Hooks/ThemeManager";
import { useNavigate } from "react-router-dom";
import sinRetencionesImg from "../static/img/retencionesIMG.png";
import { RxCross1, RxCross2 } from "react-icons/rx";
import { FiAlertTriangle, FiCheck } from "react-icons/fi";

/*--Imagenes--*/

import retencionIMG from "../static/img/retencionesIMG.png";
import { IoAlertCircleOutline, IoDocumentText, IoLogoCss3 } from "react-icons/io5";
import RetencionModal from "../components/RetencionModal";
import { GoAlertFill } from "react-icons/go";

const DropdownP = ({ data }) => {
  const [show, setShow] = useState(false);
  const dropdownRef = useRef(null);
  const { themeColors } = useThemeManager();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (show && !dropdownRef.current.contains(event.target)) {
        setShow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [show]);

  return (
    <div className="dropdownP-conten" ref={dropdownRef}>
      <div className="boton serv" onClick={() => setShow(!show)}>
        Ver Servicios
      </div>
      <div
        className={`${data.length == 0 ? "no-data" : ""} dropdownP ${show ? "fade-in" : ""}`}
        style={{ display: show ? "block" : "none" }}
      >
        <div className="arrow"></div>
        <span className="titleserv color-secondary">
          Servicios aplicables
        </span>
        <div>
          {data.length > 0 ? (
            data.map((item) => (
              <div key={item?.id} className="cardservicio">
                <div className="data-direccion">
                  <div>
                    <strong className="dir-referencia">
                      {item?.tipo_servicio === "Pyme" && <MdStore size={20} className="me-1" />}
                      {item?.tipo_servicio === "Corporativo" && <MdOutlineFactory size={20} className="me-1" />}
                      {item?.tipo_servicio === "ISP" && <AiOutlineGlobal size={20} className="me-1" />}
                      {item?.dir_referencia}
                    </strong>
                  </div>
                  <div>
                    <span className="dir-calle">{item?.dir_calle}</span>
                  </div>
                </div>
                <div className="linea-vertical"></div>
                <div className="plan">
                  {item?.tipo_servicio == "Corporativo" ? (
                    <i className="font-servicio">Tarifa plana</i>
                  ) : (
                    <i className="font-servicio">Plan de navegación</i>
                  )}
                  <div className="plan-nombre">
                    <strong>
                      {item?.tipo_servicio === "Corporativo" ? item?.tarifa + "$" : item?.plan?.nombre || "N/A"}
                    </strong>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No hay servicios disponibles.</p>
          )}
        </div>
      </div>
    </div>
  );
};

const Bills = () => {
  const navigate = useNavigate();
  const { themeColors } = useThemeManager();
  const [show, setShow] = useState(false);
  const token = localStorage.getItem("token");
  const [data, setData] = useState([]);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [retencion, setRetencion] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const pendientes = retencion?.data ? retencion.data.filter((item) => item.estado === "pendiente") : [];
  const [selectedRowData, setSelectedRowData] = useState([]);

  useEffect(() => {
    http
      .get("/intranet-j/metodos-pago", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setData(response.data);
        const numeroDeFacturas = response.data?.facturas?.length;
        const idsFacturas = response.data?.facturas?.map((factura) => factura.id) || [];
        localStorage.setItem("numeroDeFacturas", numeroDeFacturas);
        localStorage.setItem("idsFacturas", JSON.stringify(idsFacturas));
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  useEffect(() => {
    http
      .get(`/intranet-j/retenciones-pendientes`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setRetencion(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  }, []);

  const handleMethodSelect = (method) => {
    setSelectedMethod(method);
  };

  const handleNavigateToPagar = () => {
    const tieneFacturas = data?.facturas?.length > 0;
    const tieneOnline = data?.online?.length > 0;

    // Si hay ambos, va a /pagos
    if (tieneFacturas && tieneOnline) {
      navigate("/pagos", {
        state: {
          paymentData: data,
        },
      });
    }
    // Si solo hay online (abonar), va a /metodos con state abonar
    else if (tieneOnline && !tieneFacturas) {
      navigate("/metodos", {
        state: { abonar: true }
      });
    }
    // Si solo hay facturas, va a /metodos con state factura
    else if (tieneFacturas && !tieneOnline) {
      navigate("/metodos", {
        state: { factura: true }
      });
    }
    // Si no hay nada, quizás ir a una página por defecto
    else {
      navigate("/pagos"); // o la ruta que corresponda
    }
  };

  const handleShow = (rowData) => {
    setShow(true);
    setSelectedRowData(rowData);
  };

  const formatFecha = (fechaISO) => {
    const date = new Date(fechaISO);
    return new Intl.DateTimeFormat("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    }).format(date);
  };

  // Procesos anteriores de retencion
  // const handleCargarClick = () => {
  //   if (archivoInputRef.current) {
  //     archivoInputRef.current.click();
  //   }
  // };

  // const handleFileChange = (event) => {
  //   setSelectedFile(event.target.files[0]);
  //   setMimeType(event.target.files[0]?.type);
  // };

  // const handleDate = (e) => {
  //   const date = new Date(e.target.value);
  //   setDate(date.toISOString());
  // };

  // const handleFileRemove = (event) => {
  //   event.stopPropagation();
  //   setSelectedFile(null);
  //   setMimeType(null);
  //   if (archivoInputRef.current) {
  //     archivoInputRef.current.value = "";
  //   }
  // };

  // const {
  //   register,
  //   handleSubmit,
  //   watch,
  //   formState: { errors },
  // } = useForm();

  // const submit = async (data) => {
  //   data.preventDefault();

  //   if (selectedFile) {
  //     const reader = new FileReader();
  //     reader.onload = async function (event) {
  //       const base64Data = event.target.result.split(',')[1]; // Obtener solo la parte de datos en base64

  //       try {
  //         const response = await http.post(
  //           `/juridico/comprobante/retenciones/${ID_user}`,
  //           {
  //             nro_comprobante: data.target.numero.value,
  //             fecha: date,
  //             monto: data.target.monto.value,
  //             documento: base64Data,
  //             mimetype: mimeType,
  //           },
  //           {
  //             headers: {
  //               Authorization: `Bearer ${token}`
  //             }
  //           }
  //         );
  //         toast.success("Se ha cargado la retención correctamente.");
  //       } catch (error) {
  //         console.log("Ha ocurrido un error RETENCIONES.");
  //       }
  //     };
  //     reader.readAsDataURL(selectedFile);
  //   }
  // };

  return (
    <div className="contenedorPagos">
      <span className="tituloPagos color-secondary">
        Servicio de Pagos y Retenciones
      </span>
      <div className="pagosContenedor">
        <div className="realizarPagos color-secondary">
          <span className="tituloRealizar">Realizar pagos</span>
          <span className="selectMetodo">Seleccione el método de pago que desea utilizar</span>
          <div className="metodosPagos">
            {/*  <div className="metodoPago botons" onClick={() => handleMethodSelect("online")}>
              <div className="metodo">
                <AiFillDollarCircle className="iconMetodo" />
                <div className="metodoDetalle">
                  <span>Pago online</span>
                  <span>Disponible para</span>
                </div>
              </div>
              <div className="acciones">
                <DropdownP data={data.online || []} />
                <Link
                  to={{
                    pathname: "/pagos",
                  }}
                  className="boton pagar no-line"
                >
                  Pagar / Abonar
                </Link>
              </div>
            </div> */}

            <Link to="/oficina" className="metodoPago color-secondary" style={{ textDecoration: "none" }}>
              <div className="metodo">
                <MdOutlineCreditCard className="iconMetodo" />
                <div className="metodoDetalle">
                  <span>
                    <b>Pago en efectivo</b>
                  </span>
                </div>
              </div>
              <MdArrowForwardIos className="iconForward" />
            </Link>
            <div
              onClick={handleNavigateToPagar}
              className="metodoPago color-secondary"
              style={{ textDecoration: "none", cursor: "pointer" }}
            >
              <div className="metodo">
                <div className="pago-pending-wrapper">
                  <AiFillDollarCircle className="iconMetodo" />

                  {/* Icono de alerta en lugar del círculo rojo */}
                  {data?.facturas?.length > 0 && (
                    <div className="boxAlertFill-2">
                      <GoAlertFill
                        className="pago-alerta-icono-2"
                        title={data.facturas.length === 1
                          ? "Tiene 1 documento pendiente"
                          : `Tiene ${data.facturas.length} documentos pendientes`
                        }
                      />
                    </div>
                  )}
                </div>
                <div className="metodoDetalle">
                  <span>
                    <b>Pago online</b>
                  </span>
                </div>
              </div>
              <MdArrowForwardIos className="iconForward" />
            </div>
            <Link
              to="/informacion"
              className="metodoPago color-secondary"
              style={{ textDecoration: "none" }}
            >
              <div>
                <IoMdInformationCircle className="iconMetodo" />
                Información
              </div>
              <MdArrowForwardIos className="iconForward" />
            </Link>
          </div>
        </div>
        <div className={`${!retencion ? "metodoDetalles" : "d-none"} color-secondary`}>
          {!retencion && (
            <>
              <span className="titulo">¡Todo bien por acá!</span>
              <div className="info">
                <div className="infoDatos">
                  <span>No posee retenciones pendientes</span>
                  <div className="boton serv">Mis retenciones anteriores</div>
                </div>
                <div className="img">
                  <img src={retencionIMG} alt="Sin retenciones" />
                </div>
              </div>
            </>
          )}
        </div>
        <div className={`${retencion ? "retenciones" : "d-none"} color-secondary`}>
          <span className="titulo-retenciones">
            {retencion?.length === 0
              ? "Sin facturas con retenciones pendientes"
              : retencion?.length === 1
              ? `${retencion?.length} Factura con retencion pendiente`
              : `${retencion?.length} Facturas con retenciones pendientes`}
          </span>
          {retencion && retencion.length > 0 ? (
            <div>
              <Row className="header-retencion">
                <Col className="header-retencion head-left" xs={5} sm={4}>
                  Nro. Factura
                </Col>
                <Col className="header-retencion head-left" xs={4} sm={4}>
                  Fecha
                </Col>
                <Col className="header-retencion head-right" xs={3} sm={4}>
                  Retenciones pendientes
                </Col>
              </Row>
              <div className="card-retenciones">
                {loading ? (
                  <div className="contenSpinner mt-3 mb-3">
                    <div className="spinner blue"></div>
                  </div>
                ) : (
                  retencion?.map((item, index) => (
                    <Row key={index} className="row-custom">
                      <Col className="row-custom row-left" xs={5} sm={4}>
                        <span className="vertical-align">
                          <MdNewspaper size={22} /> {item?.nro_fac}
                        </span>
                      </Col>
                      <Col className="row-custom row-left" xs={4} sm={4}>
                        <div className="fecha-stack">
                          <span className="d-block text-nowrap">{formatFecha(item?.fecha_emi).split(",")[0]}</span>
                          <small className="d-block hora-texto">{formatFecha(item?.fecha_emi).split(",")[1]}</small>
                        </div>
                      </Col>
                      <Col
                        className="d-flex justify-content-center align-items-center"
                        style={{ whiteSpace: "nowrap" }}
                        xs={3}
                        sm={4}
                      >
                        <div className="position-relative d-inline-block">
                          <IoDocumentText
                            size={25}
                            className="cursor-pointer color-primary"
                            onClick={() => handleShow(item)}
                            style={{ cursor: "pointer" }}
                          />
                          {item?.retenciones?.length > 0 && (
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                              {item?.retenciones?.length > 99 ? "99+" : item?.retenciones?.length}
                              <span className="visually-hidden">Mensajes sin leer</span>
                            </span>
                          )}
                        </div>
                      </Col>
                    </Row>
                  ))
                )}
              </div>
              <Link to="/facturas" className="no-line">
                <div className="card-footer">Ver todas mis retenciones pendientes...</div>
              </Link>
            </div>
          ) : (
            // Mostrar imagen cuando no hay retenciones
            <div className="text-center p-4">
              <img
                src={sinRetencionesImg}
                alt="Sin retenciones pendientes"
                style={{
                  maxWidth: "400px",
                  width: "100%",
                  marginBottom: "1rem",
                  opacity: 0.8,
                }}
              />
              <h5 className="color-secondary">Todas tus retenciones están al día</h5>
            </div>
          )}
        </div>

        {/* Cargar una retención proceso anterior */}
        {/* <div className="metodoDetalles">
          <span className="tituloRealizar">Cargar retención</span>
          <span className="selectMetodo">Rellene los datos para cargar su retención</span>
          <form className="formulario" onSubmit={submit}>
            <div className="campoPagos">
              <span className="formPagosText">Numero del comprobante:</span>
              <input type="text" className="inputPagos" {...register("numero")} placeholder="Ingresar numero de comprobante..." />
            </div>
            <div className="columnasPagos">
              <div className="campoPagos">
                <span className="formPagosText">Fecha de la retención:</span>
                <input
                  id="session-date"
                  name="session-date"
                  className="inputPagos"
                  type="date"
                  ref={dateRef}
                  onChange={handleDate}
                  onClick={() => {
                    dateRef.current.showPicker();
                  }}
                />
              </div>
              <div className="campoPagos">
                <span className="formPagosText">Monto que desea retener:</span>
                <input type="text" className="inputPagos" {...register("monto")} placeholder="0.00 BsD" />
              </div>
            </div>
            <div className="documentoRetencion">
              <span className="formPagosText">Documento de retención:</span>
              <div className="cargarDocumentoRetencion" onClick={handleCargarClick}>
                {selectedFile ? (
                  <>
                    <PiFilePdf className="iconDocRetencion loginIn" />
                    <div className="tituloPDF loginIn"><b>{selectedFile.name}</b><div className="pdfDelete" onClick={handleFileRemove}><MdDeleteOutline /></div></div>
                  </>
                ) :
                  <MdNewspaper className="iconDocRetencion loginIn" />
                }
                <input
                  type="file"
                  id="archivoInput"
                  ref={archivoInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
              </div>
            </div>
            <div className="contenedorBotonPagos">
              <button type="submit">Confirmar</button>
            </div>
          </form>
        </div> */}
      </div>
      <RetencionModal
        data={selectedRowData}
        show={show}
        onHide={() => {
          setShow(false);
        }}
      />
      <RespondIpg />
    </div>
  );
};

const RespondIpg = () => {
  const [ipg, setIpg] = useState(false);
  const [status, setstatus] = useState(false);
  const [referencia, setReferencia] = useState("initialState");
  const [message, setMessage] = useState("");
  const { themeColors } = useThemeManager();

  const obtenerIdDeURL = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("id");
    return id;
  };

  const handleClose = () => setIpg(false);

  useEffect(() => {
    const id = obtenerIdDeURL();
    if (id) {
      modalIpg(id);
    }
  }, []);

  const modalIpg = async (id) => {
    try {
      const token = localStorage.getItem("token");
      const response = await http.get(`/bdv/ipg/${id}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {}
      });
      setReferencia(response.data);
      setIpg(true);
      setstatus(true);
    } catch (error) {
      setIpg(true);
      setstatus(false);
      if (error.response && [400, 401, 404, 409, 503].includes(error.response.status)) {
        setMessage(error.response.data.detail || "Error al validar el pago");
      } else {
        setMessage("Error desconocido");
      }
    }
  };

  return (
    <Modal size="lg" show={ipg} centered onHide={() => { }} backdrop="static" keyboard={false}>
      <div className="d-flex justify-content-end">
        <button onClick={handleClose} className="eliminarBG me-4 mt-2">
          <RxCross2 className="color-primary" style={{ fontSize: 35 }} />
        </button>
      </div>

      <Modal.Body className="text-center">
        {status ? (
          <div className="p-5">
            <div style={{ fontSize: "120px" }}>
              <FiCheck className="success-icon" />
            </div>
            <div style={{ color: themeColors.secundary }}>
              <h2>Su pago se realizó de forma exitosa</h2>
              <h5>Referencia: {referencia?.ref} </h5>
            </div>
          </div>
        ) : (
          <div className="p-5">
            <div className="error-icon" style={{ fontSize: "120px" }}>
              <RxCross1 />
            </div>
            <div className="color-secondary">
              <h2>{message}</h2>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};


export default Bills;
